/*
 * Project: BookingEngine
 * Module: api.js
 */

import { store } from './Store';

const Raven = {
  captureException: () => null,
}; // Overriding Raven to silence it while in development

const ravenError = (error) => {
  const errorDesc = error || '';
  store.getState(); // Loading the State
  Raven.captureException(errorDesc);
};

const getHeaders = (lang) => {
  const state = store.getState();
  return {
    Accept: 'application/json, text/plain, */*',
    'Content-Type': 'application/json',
    'Accept-Language': lang,
    Device: state.booking.device,
    AgentCode: state.bookingFormState.agentCode != null ? state.bookingFormState.agentCode : '',
    AgentSell: state.bookingFormState.agentSell != null ? state.bookingFormState.agentSell : 'false',
    RateType: state.booking.rateType != null ? state.booking.rateType : 'PUBLIC_RATE',
    AgentUseCoins: state.bookingFormState.agentUseCoins ? state.bookingFormState.agentUseCoins : 'true',
    // Mandamos en el header si es un agentCode
    // En el booking core se logea al agente usando
    // su agentCode
    CallCenterSelectedCustomerCode:
      state.session.callCenterCustomerCode != null
        ? state.session.callCenterCustomerCode.code
        : null,
    IsEditingBooking: state.booking.isEditingBooking,
    DingusCustomerCodeUsedInEditingBooking: state.booking.dingusCustomerCodeUsedInEditingBooking,
    EditBookingToken: state.booking.editBookingToken,
    BookingOrigin: state.bookingFormState.origin ? state.bookingFormState.origin : 'BOOKING',
  };
};

const getBody = ({ body, method, lang }) => ({
  method: method || 'GET',
  body: body ? JSON.stringify(body) : undefined,
  headers: getHeaders(lang),
});

const apiGet = (url, lang, options = {}) => {
  const body = getBody({ lang });
  return fetch(`${process.env.API_URL}/${url}`, body)
    .then((response) => {
      if (response.status >= 400) {
        ravenError(response.statusText);
        return null;
      }
      return options.isBlob ? response.blob() : response.json();
    })
    .catch((e) => {
      ravenError(e);
      return null;
    });
};

const apiPost = (url, body, lang, onError = () => {}) => {
  const requestBody = getBody({ body, lang, method: 'POST' });
  return fetch(`${process.env.API_URL}/${url}`, requestBody)
    .then((response) => {
      if (response.status >= 400) {
        ravenError(JSON.stringify(response.data));
        onError(response);
        return null;
      }
      return response.json();
    })
    .catch((e) => {
      ravenError(e);
      return null;
    });
};

const apiPut = (url, body, lang, onError = () => {}) => {
  const requestBody = getBody({ body, lang, method: 'PUT' });
  return fetch(`${process.env.API_URL}/${url}`, requestBody)
    .then((response) => {
      if (response.status >= 400) {
        ravenError(JSON.stringify(response.data));
        onError(response);
        return null;
      }
      return response.json();
    })
    .catch((e) => {
      ravenError(e);
      return null;
    });
};

export {
  apiGet,
  apiPost,
  apiPut,
};
